<div class="modal-header">
  <h3 class="modal-title">
    {{ 'employeeModule.setCalenderBlock' | translate }}
  </h3>
  <button
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'wcag.close' | translate }}"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <form
    *ngIf="form"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    #formRef="ngForm"
  >
    <div class="mb-4">
      <label id="daysId" class="form-label">
        {{ 'general.selectDays' | translate }}
      </label>

      <custom-select-multiple
        [ariaLabelledby]="'daysId'"
        [ariaDescribedby]="'days'"
        formControlName="days"
        [selectableItems]="multiSelectItems"
        [defaultSelectedItems]="selectedItems"
        [clearable]="true"
        [emptyInitValue]="true"
        [disabled]="false"
        (click)="$event.stopPropagation()"
        [valueBinder]="'value'"
        (change)="adjustSelectedDays($event)"
        [attr.aria-invalid]="
          form.controls.days.dirty && form.controls.days.invalid ? 'true' : null
        "
      >
      </custom-select-multiple>

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="days"
        role="alert"
        *ngIf="form.controls.days.dirty && form.controls.days.invalid"
      >
        {{ 'general.value' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>
    <div class="mb-4 row">
      <div class="col-md-auto">
        <label class="form-label" id="startTimeLabel">
          {{ 'general.startTime' | translate }}
        </label>

        <time-input
          formControlName="startTime"
          aria-labelledby="startTimeLabel"
        ></time-input>
      </div>

      <div class="col-md-auto">
        <label class="form-label" id="endTimeLabel">
          {{ 'general.endTime' | translate }}
        </label>

        <time-input
          formControlName="endTime"
          aria-labelledby="endTimeLabel"
        ></time-input>
      </div>
    </div>

    <div
      class="d-flex"
      [ngClass]="{
        'justify-content-between': timeBlock?.id,
        'justify-content-end': !timeBlock?.id
      }"
    >
      <button
        class="btn btn-soft-primary"
        [hidden]="!timeBlock?.id"
        (click)="onClickDeleteBlock()"
        type="button"
      >
        {{ 'general.deleteBlock' | translate }}
      </button>
      <button class="btn btn-primary" type="submit" [disabled]="!form.dirty">
        {{ 'general.save' | translate }}
      </button>
    </div>
  </form>
</div>
